import { oc } from '@orpc/contract';
import { createSegmentInputSchema, segmentSchema } from '../schemas/segments.schemas.js';
export const createSegmentContract = oc
    .route({
    method: 'POST',
    path: '/segments',
    tags: ['Segments'],
    summary: 'Create a vehicle segment',
    description: 'MANAGER only. Segment names are unique.',
})
    .input(createSegmentInputSchema)
    .output(segmentSchema);
//# sourceMappingURL=create-segment.contract.js.map